// Canonical enum registry — mirror of packages/prisma/prisma/schema.prisma §C-1
//
// Single source of truth: docs/plan/_verification/decisions.md §C-1.
// If you change a value here, update schema.prisma AND run `prisma generate`.
export const OwnerEntity = {
    HONEYCOMB_ROBOTICS: 'HONEYCOMB_ROBOTICS',
    BEYOND_HONEYCOMB: 'BEYOND_HONEYCOMB',
};
export const RobotStatus = {
    IN_PRODUCTION: 'IN_PRODUCTION',
    READY_TO_SHIP: 'READY_TO_SHIP',
    // S2 §9.1 — 로봇 라이프사이클 '설치 대기' (제조 할당+필드 설치일정 확정 후
    // ~ operator-pwa 인수 전). CustomerMasterStatus.install_ready 와 별개.
    INSTALL_PENDING: 'INSTALL_PENDING',
    DEPLOYED: 'DEPLOYED',
    IN_AS: 'IN_AS',
    RETIRED: 'RETIRED',
    IN_STORAGE: 'IN_STORAGE',
    // round10 요구2 — '폐기 예정'(장부 잔존) vs RETIRED='폐기 완료'(상각) 구분.
    RETIREMENT_PLANNED: 'RETIREMENT_PLANNED',
    // 오너 결정 2026-09-18 — **'운영중' 은 고객사에서 실제로 도는 로봇만.**
    //
    // 종전엔 배치가 종류(고객·행사·파일럿·사내)를 보지 않고 전부 '운영중' 을 찍어,
    // 행사에 나간 로봇과 매장에서 도는 로봇이 같은 칸에 섞였다. 대시보드는 그걸
    // 알고 빼서 세고 있었고(dashboard.service 의 eventDeployedCount), 그래서 같은
    // '운영중' 인데 화면마다 숫자가 달랐다.
    //
    // '재고(IN_STORAGE)' 로 대신하지 않는 이유 둘:
    //   ① 뜻이 정반대다 — 전시장에 나가 있는 로봇을 "창고에 있다" 로 읽게 된다.
    //   ② 재고는 **계약 배정 후보**다(assignments 의 STOCK_ASSIGNABLE_STATUSES).
    //      나가 있는 로봇이 "이 로봇 쓰세요" 로 제안된다.
    OTHER: 'OTHER',
};
// FB2 §1 (결정 F) — 로봇 상태의 단일 정전(canonical) 한국어 라벨 맵.
// 라이프사이클 KPI 카드 표기('운영중'/'정비'/'재고')를 기준으로 통일한다.
// 이 맵을 RobotsListPage STATUS_OPTIONS / RobotForm 상태 select /
// StatusPill 이 함께 소비하여 파일별 하드코딩으로 인한 라벨 표류를 차단.
//
// 주의: apps/windows/src/lib/enum-labels.ts 의 ROBOT_STATUS_LABEL 은
// 대시보드 KPI 용 별도 표기('생산 중'/'출하 준비' 등)로, 본 맵과 의도가
// 다르므로 통합하지 않는다.
export const ROBOT_STATUS_LABELS = {
    IN_PRODUCTION: '제조 중',
    READY_TO_SHIP: '출고 대기',
    INSTALL_PENDING: '설치 대기',
    DEPLOYED: '운영중',
    IN_AS: '정비',
    // round10 요구2 — RETIRED 라벨 '폐기'→'폐기 완료', 예정 신설.
    RETIRED: '폐기 완료',
    IN_STORAGE: '재고',
    RETIREMENT_PLANNED: '폐기 예정',
    // 오너 결정 2026-09-18 — 행사·인증·테스트·사내로 나가 있는 로봇.
    // "회사 자산이지만 고객 서비스 중도 아니고, 팔 수 있는 재고도 아니다."
    OTHER: '기타',
};
// S2 §3.2 — 로봇 생산 구분 (양산/수리품/재작업). Prisma RobotBuildKind 미러.
export const RobotBuildKind = {
    NEW: 'NEW',
    REFURBISHED: 'REFURBISHED',
    REWORK: 'REWORK',
};
// S2 §3.1 — RobotEcn 적용 출처. Prisma RobotEcnSource 미러.
export const RobotEcnSource = {
    MANUAL: 'MANUAL',
    BATCH: 'BATCH',
    IMPORTED: 'IMPORTED',
};
// docs/plan/team-dashboards-and-production-handoff/plan.md §5.1
export const ProductionPlanStatus = {
    PLANNED: 'PLANNED',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
    PARTIALLY_COMPLETED: 'PARTIALLY_COMPLETED',
    DELAYED: 'DELAYED',
    CANCELLED: 'CANCELLED',
};
export const ContractHandoffStatus = {
    PENDING_SIGN: 'PENDING_SIGN',
    SIGNED_AWAITING_ASSIGNMENT: 'SIGNED_AWAITING_ASSIGNMENT',
    ASSIGNED_AWAITING_INSTALL: 'ASSIGNED_AWAITING_INSTALL',
    INSTALLED: 'INSTALLED',
    CANCELLED: 'CANCELLED',
};
export const LocationCategory = {
    // docs/work_log/pdf-feedback-2026-05-24 §Phase A — 운영자 요청 (수정
    // 사항 PDF 페이지 3 §3): 5개 옵션 노출 (연구소/공장/창고/고객 현장/
    // 폐기). RESEARCH 신규 추가. AS_CENTER 는 backward-compat 유지하되
    // UI dropdown 에선 hidden.
    RESEARCH: 'RESEARCH',
    FACTORY: 'FACTORY',
    WAREHOUSE: 'WAREHOUSE',
    CUSTOMER_SITE: 'CUSTOMER_SITE',
    AS_CENTER: 'AS_CENTER',
    DISPOSAL: 'DISPOSAL',
};
export const VerificationStatus = {
    CONFIRMED: 'CONFIRMED',
    PHANTOM: 'PHANTOM',
    TENTATIVE_OWNERSHIP: 'TENTATIVE_OWNERSHIP',
    MISSING_SERIAL: 'MISSING_SERIAL',
};
export const AccountingScheme = {
    GRILLX_24: 'GRILLX_24',
    GEN1_D2_25: 'GEN1_D2_25',
    GEN2_25: 'GEN2_25',
    OPERATING_LEASE: 'OPERATING_LEASE',
    LEGACY_SILJUNG: 'LEGACY_SILJUNG',
    DEPRECIATED_MARKED: 'DEPRECIATED_MARKED',
    UNKNOWN: 'UNKNOWN',
};
export const DeploymentKind = {
    CUSTOMER: 'CUSTOMER',
    EVENT: 'EVENT',
    PILOT: 'PILOT',
    INTERNAL: 'INTERNAL',
    // 오너 요청 2026-09-18 — 인증·시험은 파일럿과 섞으면 나중에 못 가린다.
    // "인증기관에 나가 있는 로봇이 몇 대인가" 에 답할 수 있어야 한다.
    CERTIFICATION: 'CERTIFICATION',
    TEST: 'TEST',
};
/**
 * 배치 종류 한글 이름표 — **화면·알림·감사 장부가 같은 정본을 쓴다.**
 *
 * 종전엔 배치 창의 select 안에만 글자가 박혀 있어서, 목록·감사 장부는 영문
 * 코드를 그대로 보여 줬다.
 */
export const DEPLOYMENT_KIND_LABELS = {
    CUSTOMER: '고객 배치',
    EVENT: '행사·전시',
    PILOT: 'PoC·파일럿',
    INTERNAL: '사내 사용',
    CERTIFICATION: '인증·시험',
    TEST: '테스트',
};
/**
 * **이 배치는 로봇을 어떤 상태로 만드는가 — 정본 한 벌.**
 *
 * 오너 결정 2026-09-18: '운영중' 은 고객사에서 실제로 도는 로봇만이다.
 * 행사·인증·테스트·사내·파일럿은 전부 '기타' 다.
 *
 * ⚠ 이 함수를 거치지 않고 상태를 직접 찍는 자리를 만들지 말 것. 종전에 배치
 *   생성·이어달기 두 곳이 각자 `RobotStatus.DEPLOYED` 를 박아 두어, 종류를
 *   아무리 골라도 상태가 안 갈렸다.
 *
 * 파일럿이 '기타' 인 이유: 오너가 round5 #19 에서 "운영중 = 고객 배치만,
 * 파일럿은 PoC/내부 검증" 으로 이미 정했다. 파일럿을 운영중에 두면 로봇 목록의
 * 운영중과 대시보드의 운영중이 파일럿 수만큼 계속 어긋난다.
 */
export function robotStatusForDeploymentKind(kind) {
    return kind === DeploymentKind.CUSTOMER ? RobotStatus.DEPLOYED : RobotStatus.OTHER;
}
export const DeploymentReason = {
    SALE: 'SALE',
    LEASE_OPERATING: 'LEASE_OPERATING',
    LEASE_FINANCE: 'LEASE_FINANCE',
    PILOT: 'PILOT',
    DEMO: 'DEMO',
    EVENT: 'EVENT',
    INTERNAL: 'INTERNAL',
};
// 회수 사유(개선계획 §7, 결정 ⑧/⑩/⑪). 회수 창에서 선택하며 Deployment 행에
// 남는다. SWAP_DEFECT(고장 교체)는 고객사 자동 종료를 억제하는 유일한 값 —
// 1대 고객사의 교체 회수 도중 고객사가 종료돼 목록에서 사라지는 사고 방지.
export const DeploymentReturnReason = {
    CONTRACT_END: 'CONTRACT_END',
    SWAP_DEFECT: 'SWAP_DEFECT',
    CLOSURE: 'CLOSURE',
    OTHER: 'OTHER',
};
export const DEPLOYMENT_RETURN_REASON_LABELS = {
    CONTRACT_END: '계약 만료',
    SWAP_DEFECT: '고장 교체',
    CLOSURE: '폐업',
    OTHER: '기타',
};
export const CustomerSegment = {
    // plan-v0.4.0.md §O-3 — semantically-correct default for soft-record
    // rows whose segment is not yet known. Replaces the pragmatic-but-
    // wrong INDEPENDENT_RESTAURANT fallback used since v0.3.0.
    UNKNOWN: 'UNKNOWN',
    FRANCHISE_HQ: 'FRANCHISE_HQ',
    FRANCHISE_STORE: 'FRANCHISE_STORE',
    INDEPENDENT_RESTAURANT: 'INDEPENDENT_RESTAURANT',
    HOTEL_RESORT: 'HOTEL_RESORT',
    CATERING: 'CATERING',
    RETAIL_CHAIN: 'RETAIL_CHAIN',
    CAFE: 'CAFE',
    BAKERY: 'BAKERY',
    CLOUD_KITCHEN: 'CLOUD_KITCHEN',
    EDUCATION: 'EDUCATION',
    RESEARCH: 'RESEARCH',
    GOVERNMENT: 'GOVERNMENT',
    EXPORT_DISTRIBUTOR: 'EXPORT_DISTRIBUTOR',
    INTERNAL_OPS: 'INTERNAL_OPS',
};
// Plan §C-2 — split MANAGER into team-specific roles to support PDF p.17
// "계약 금액에 대해서는 다른 팀에서 볼 수 없음". The generic MANAGER role
// is kept for backwards compatibility (existing users + 387 reference
// sites in the codebase that still check role === MANAGER); new users
// should be created with the team-specific role that matches their team.
//
// Use the helpers in @/permissions (apps/windows) to check capabilities;
// don't compare role values directly in new UI code.
export const UserRole = {
    ADMIN: 'ADMIN',
    /** @deprecated Prefer SALES_MANAGER / MFG_MANAGER / FIELD_MANAGER for new users. */
    MANAGER: 'MANAGER',
    SALES_MANAGER: 'SALES_MANAGER',
    MFG_MANAGER: 'MFG_MANAGER',
    FIELD_MANAGER: 'FIELD_MANAGER',
    VIEWER: 'VIEWER',
};
// Plan §E-5-1 (PDF p.22) — in-app workflow notification enums.
// Mirrors prisma's `NotificationType` / `NotificationTeam` enums
// so the windows + portal clients can typecheck against them
// without importing from @bhops/prisma directly.
export const NotificationType = {
    CONTRACT_ACTIVATED: 'CONTRACT_ACTIVATED',
    CONTRACT_EXPIRING: 'CONTRACT_EXPIRING',
    INFRA_ORDER_CONTACTED: 'INFRA_ORDER_CONTACTED',
    INFRA_ORDER_DELIVERED: 'INFRA_ORDER_DELIVERED',
    INFRA_ORDER_INSTALLED: 'INFRA_ORDER_INSTALLED',
    ROBOT_ASSIGNED: 'ROBOT_ASSIGNED',
    ROBOT_READY_TO_SHIP: 'ROBOT_READY_TO_SHIP',
    REPORT_NEW: 'REPORT_NEW',
    REPORT_SLA_BREACH: 'REPORT_SLA_BREACH',
    // batch-15 §5.1 / §9.2 — Contract 사인 후 핸드오프 알람
    CONTRACT_SIGNED_AWAITING_MFG_ASSIGNMENT: 'CONTRACT_SIGNED_AWAITING_MFG_ASSIGNMENT',
    CONTRACT_SIGNED_AWAITING_FIELD_INFRA: 'CONTRACT_SIGNED_AWAITING_FIELD_INFRA',
    ROBOT_ASSIGNED_TO_CONTRACT: 'ROBOT_ASSIGNED_TO_CONTRACT',
    PRODUCTION_PLAN_DELAYED: 'PRODUCTION_PLAN_DELAYED',
    PRODUCTION_PLAN_COMPLETED: 'PRODUCTION_PLAN_COMPLETED',
    // 통합 S1/S2/S3 신규 4 (기존 handoff 알람 재사용 외 — unified plan §2).
    CUSTOMER_RETURN_PLANNED: 'CUSTOMER_RETURN_PLANNED', // S1 회수 예정 → 필드
    ROBOT_ASSIGNMENT_REQUESTED: 'ROBOT_ASSIGNMENT_REQUESTED', // S1 '할당 요청' → 제조
    INFRA_CONTACT_REQUESTED: 'INFRA_CONTACT_REQUESTED', // S1 '연락 요청' → 필드
    ROBOT_REPLACEMENT_REQUESTED: 'ROBOT_REPLACEMENT_REQUESTED', // S3 로봇 교체 → 제조
    // S2 Phase 2.5 — 배정 완료 시 필드에 설치 일정 요청 (ROBOT_ASSIGNED→사업과 동시 fan-out).
    ROBOT_INSTALL_SCHEDULE_REQUESTED: 'ROBOT_INSTALL_SCHEDULE_REQUESTED',
};
export const NotificationTeam = {
    SALES: 'SALES',
    MFG: 'MFG',
    FIELD: 'FIELD',
};
// Plan §E-3 — InfrastructureOrder.gasType.
export const GasType = {
    LPG: 'LPG',
    LNG: 'LNG',
    UNDECIDED: 'UNDECIDED',
};
/**
 * 가스 종류 한글 이름표 — **콘솔과 슬랙이 같은 정본을 쓴다.**
 *
 * 종전엔 콘솔 안에만 명부가 있어서, 같은 발주를 콘솔은 '미정' 으로 슬랙 카드는
 * `UNDECIDED` 로 보여 줬다(2026-09-16 '연락 요청' 카드 도입). 전부 한글인 카드
 * 한가운데에 영문 코드가 섞이면 받는 사람이 다른 값으로 읽는다.
 */
export const GAS_TYPE_LABELS = {
    LPG: 'LPG',
    LNG: 'LNG',
    UNDECIDED: '미정',
};
// Plan §D-4 (PDF p.12) — 3-track firmware history per robot.
//   BINARY     — 펌웨어 바이너리 (HW 직접 제어)
//   BUNDLE     — 솔루션 번들 (조리 레시피 등)
//   TABLET_APP — 태블릿 앱 (UI / 상호작용)
export const FirmwareTrack = {
    BINARY: 'BINARY',
    BUNDLE: 'BUNDLE',
    TABLET_APP: 'TABLET_APP',
};
export const ReportStatus = {
    NEW: 'NEW',
    TRIAGED: 'TRIAGED',
    ASSIGNED: 'ASSIGNED',
    IN_PROGRESS: 'IN_PROGRESS',
    RESOLVED: 'RESOLVED',
    DISMISSED: 'DISMISSED',
    DUPLICATE: 'DUPLICATE',
};
export const ReportCategory = {
    HARDWARE_FAILURE: 'HARDWARE_FAILURE',
    COOKING_QUALITY: 'COOKING_QUALITY',
    CLEANING_HYGIENE: 'CLEANING_HYGIENE',
    DISPENSING: 'DISPENSING',
    CONNECTIVITY: 'CONNECTIVITY',
    UI_UX: 'UI_UX',
    OTHER: 'OTHER',
};
export const ReportSeverity = {
    URGENT: 'URGENT',
    NORMAL: 'NORMAL',
};
// --- PrivacyRequest (DSAR intake, docs/plan/12-auth-and-security.md §6.2) --
export const PrivacyRequestType = {
    ACCESS: 'ACCESS',
    CORRECTION: 'CORRECTION',
    DELETION: 'DELETION',
    RESTRICTION: 'RESTRICTION',
    OTHER: 'OTHER',
};
export const PrivacyRequestStatus = {
    RECEIVED: 'RECEIVED',
    IN_REVIEW: 'IN_REVIEW',
    FULFILLED: 'FULFILLED',
    REJECTED: 'REJECTED',
};
// --- FieldVisit + Attachment (Phase 2 / v1.2 — merged from master) --------
export const FieldVisitKind = {
    INSTALLATION: 'INSTALLATION',
    MAINTENANCE: 'MAINTENANCE',
    INSPECTION: 'INSPECTION',
    AS_REPAIR: 'AS_REPAIR',
    DECOMMISSION: 'DECOMMISSION',
};
export const FieldVisitStatus = {
    SCHEDULED: 'SCHEDULED',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED',
};
export const AttachmentStatus = {
    PENDING: 'PENDING',
    UPLOADED: 'UPLOADED',
    ABANDONED: 'ABANDONED',
};
export const AttachmentOwnerType = {
    CUSTOMER_REPORT: 'CustomerReport',
    FIELD_VISIT: 'FieldVisit',
    // docs/plan/customer-master-ux/plan.md §3.1 §8 — 통합 시트의 3종 첨부.
    // ownerId 는 Customer.id. ownerType 별로 분리하여 한 Customer 가 여러
    // 카테고리의 첨부를 가질 수 있게 함 (설치 / 간택기 / 인수교육).
    CUSTOMER_MASTER_INSTALL: 'CustomerMasterInstall', // 설치 사진
    CUSTOMER_MASTER_SELECTOR: 'CustomerMasterSelector', // 간택기 연결 사진
    CUSTOMER_MASTER_TRAINING: 'CustomerMasterTraining', // 인수/교육 확인증
    // docs/work_log/v1026-remaining-work-batch-7 — 공개 채널 AS 신청의 사진 첨부.
    // ownerId = ServiceOrder.id. 사용자가 신청 단계에서 업로드 → 운영자 inbox 에서 확인.
    SERVICE_ORDER: 'ServiceOrder',
    // docs/work_log/v1028-remaining-work-batch-9 — 공개 AS 신청 OTP 발급 전 사진
    // 임시 보관용. ownerId = client-generated UUID (placeholder).
    // submit 성공 시 PATCH /attachments/:id/owner 로 ServiceOrder 로 이전.
    // 미이전된 PENDING attachment 는 24h 후 janitor 가 cleanup (별 PR).
    PENDING_PUBLIC_SERVICE_REQUEST: 'PendingPublicServiceRequest',
    // 계획서(2026-08-27) 요구 3 / 결정 4 — **회수한 로봇 사진.**
    //
    // ownerId = **Deployment.id**(그 로봇의 그 회수), Customer.id 가 아니다.
    // 왜: 고객사에 통째로 붙이면 "어느 로봇을 언제 회수했을 때의 사진인가"를
    // 나중에 가를 수 없다. 같은 고객사에서 로봇을 여러 번 회수하면 사진이 한 무더기로
    // 섞이고, 그때는 파일명 말고 근거가 없다. 배치 기록에 붙이면 로봇·회수일이
    // 사진마다 따라온다.
    DEPLOYMENT_RETURN: 'DeploymentReturn',
};
// --- Deal / Contract (Phase 5 / v1.1) -------------------------------------
//
// Per docs/design/phase-5-deal-contract-module.md §3.1 + plan §04
// §BR-DEAL-* / §BR-CNT-*. DealStage canonicalization (6-stage list)
// resolved 2026-04-25 in QC-WF-04 — see
// docs/work_log/dealstage-reconciliation/.
export const DealStage = {
    LEAD: 'LEAD',
    QUALIFIED: 'QUALIFIED',
    PROPOSAL: 'PROPOSAL',
    NEGOTIATION: 'NEGOTIATION',
    ACTIVE: 'ACTIVE',
    CHURNED: 'CHURNED',
};
export const DealChurnReason = {
    COST: 'COST',
    TIMING: 'TIMING',
    COMPETITOR: 'COMPETITOR',
    NO_RESPONSE: 'NO_RESPONSE',
    OTHER: 'OTHER',
};
export const DealActivityKind = {
    CALL: 'CALL',
    MEETING: 'MEETING',
    EMAIL: 'EMAIL',
    PROPOSAL_SENT: 'PROPOSAL_SENT',
    CUSTOM: 'CUSTOM',
};
export const DealCategory = {
    NEW: 'NEW',
    RENEWAL: 'RENEWAL',
    EXPANSION: 'EXPANSION',
};
export const ContractStatus = {
    DRAFT: 'DRAFT',
    ACTIVE: 'ACTIVE',
    EXPIRED: 'EXPIRED',
    TERMINATED: 'TERMINATED',
};
export const ContractTerminationReason = {
    EARLY_BREAKOFF: 'EARLY_BREAKOFF',
    CHURN_CASCADE: 'CHURN_CASCADE',
    RENEWAL_REPLACED: 'RENEWAL_REPLACED',
    CUSTOMER_REQUEST: 'CUSTOMER_REQUEST',
    OTHER: 'OTHER',
};
export const PricingScheme = {
    MONTHLY: 'MONTHLY',
    ONE_TIME: 'ONE_TIME',
    PARTIAL: 'PARTIAL',
};
// 개선계획 9건 §6 / 부록 A-6 — 갱신 원장(ContractRenewalEvent) 행의 출처.
// 지표 신뢰도가 값마다 다르다: LIVE_SAVE 만 당시 대수·월액 스냅샷이 채워지고,
// BACKFILL·MANUAL 은 스냅샷이 비어 있을 수 있어 집계가 출처를 구분해야 한다.
// Prisma ContractRenewalSource 미러 — 값 변경 시 schema.prisma 동기화.
export const ContractRenewalSource = {
    LIVE_SAVE: 'LIVE_SAVE', // 고객사 화면 저장에서 자동 감지
    BACKFILL: 'BACKFILL', // 감사 로그 역산(2026-06-03 이후분)
    MANUAL: 'MANUAL', // 검수 시 수기 보충
};
export const CONTRACT_RENEWAL_SOURCE_LABELS = {
    LIVE_SAVE: '자동 기록',
    BACKFILL: '기록 역산',
    MANUAL: '수기 보충',
};
export const MODEL_CODES = [
    'GEN1_PROFILE',
    'GEN1_D1',
    'GEN1_D2',
    'GEN2',
    'HEADLESS',
    'ZEPHYR',
    'UNKNOWN',
];
// plan-field-acceptance.md §F-1 — robot acceptance receipt lifecycle.
// Maintained in parity with the Prisma `AcceptanceStatus` enum
// (see schema.prisma — "Field acceptance receipts" section).
export const AcceptanceStatus = {
    DRAFT: 'DRAFT', // operator started, not yet submitted
    SUBMITTED: 'SUBMITTED', // local DB committed, queued / pending sync
    SYNCED: 'SYNCED', // header + photos uploaded, signature not yet attached
    SIGNED: 'SIGNED', // signature attached, awaiting finalize
    FINALIZED: 'FINALIZED', // PDF generated, immutable, hash anchored
    VOIDED: 'VOIDED', // admin-only revoke (fraud / dispute)
};
// plan-field-acceptance.md §F-3d — template selector. Production
// has 3 distinct signature-required document templates; each maps
// to a different PDF layout (rendered in F-3g) but shares the same
// lifecycle + audit chain. Existing rows pre-F-3d default to
// DELIVERY_RECEIPT (closest match to F-1/F-2/F-3 single-signer
// 인수증 design).
export const AcceptanceDocumentType = {
    DELIVERY_RECEIPT: 'DELIVERY_RECEIPT', // 인수증 (e.g. ver251204) — B2B item-delivery proof
    INSTALLATION_TRAINING: 'INSTALLATION_TRAINING', // 설치·교육 인수증 (incl. customer-specific variants)
    REMOTE_SERVICE_CONSENT: 'REMOTE_SERVICE_CONSENT', // 데이터 수집·이용 동의서
};
// plan-field-acceptance.md §F-3d — checklist sections on the
// 설치·교육 인수증 templates. Each section becomes a header on the
// rendered PDF; OTHER is a fallback for templates that introduce
// a new section before we have time to model it.
export const AcceptanceChecklistSection = {
    INSTALLATION_VERIFICATION: 'INSTALLATION_VERIFICATION', // 설치 확인 체크리스트
    TRAINING_VERIFICATION: 'TRAINING_VERIFICATION', // 교육 확인 체크리스트
    SPECIAL_EMPHASIS: 'SPECIAL_EMPHASIS', // 불판 관리 특별 강조
    OTHER: 'OTHER',
};
// plan-field-acceptance.md §F-3f — signatory roles. Each row in
// `RobotAcceptanceSignatory` carries one of these. ACCEPTOR is
// the legacy single-signer role from F-1/F-2/F-3; the others are
// new template-specific roles.
export const AcceptanceSignatoryRole = {
    CUSTOMER_REP: 'CUSTOMER_REP', // 고객 담당자
    INSTALLER: 'INSTALLER', // 설치팀
    ACCEPTOR: 'ACCEPTOR', // 인수자 (legacy default)
    CORPORATE_OFFICER: 'CORPORATE_OFFICER', // 대표자(또는 담당자)
    OTHER: 'OTHER',
};
// plan-field-service-orders.md §F-1 — v0.5.0 service order
// taxonomy. Each robot can spawn many SOs over its lifetime;
// PREVENTIVE is auto-scheduled from AcceptanceSigned (+90 days
// from sign), REACTIVE is auto-spawned from CustomerReportSubmitted,
// the rest are operator-initiated.
export const ServiceOrderCategory = {
    PREVENTIVE: 'PREVENTIVE', // 정기 점검
    REACTIVE: 'REACTIVE', // 고장 / 이상 신고 대응
    INSTALL: 'INSTALL', // 신규 설치 (acceptance와 별개의 운영 작업)
    REMOVAL: 'REMOVAL', // 회수
    PARTS_SWAP: 'PARTS_SWAP', // 부품 교체
};
// S3 §3.5 — 유지보수 작업 세부 분류 (ServiceOrderCategory 와 직교). Prisma 미러.
// ROBOT_REPLACE → 제조팀 알람(ROBOT_REPLACEMENT_REQUESTED) + 제조 캘린더.
export const MaintenanceType = {
    PART_REPLACE: 'PART_REPLACE', // 부품 교체
    FIRMWARE_UPDATE: 'FIRMWARE_UPDATE', // 펌웨어 업데이트
    ROBOT_REPLACE: 'ROBOT_REPLACE', // 로봇 교체
};
// plan-field-service-orders.md §F-1 / §6 — three severity
// buckets with distinct triage / resolve / verify SLAs.
// Mirrors the existing CustomerReport severity scale for
// consistency.
// 고장 조치 이력의 상태 — 시트('필드팀 유지보수' 월별 탭)의 `상태` 열 어휘.
// 서비스 오더 9종과 섞지 않는다: 저쪽은 발주의 수명주기고, 이쪽은 "현장에서
// 손본 결과가 지금 어떤가" 다.
// 고장 조치 이력이 고객사 리포트에 **어떻게** 묶였는가.
// 근거를 남기는 이유: STORE_TIME 은 추측이다. 화면이 추측을 확정처럼 보여주면
// 사람이 그걸 믿고 넘어간다.
export const RemediationMatchSource = {
    REPORT_NO: 'REPORT_NO',
    STORE_TIME: 'STORE_TIME',
    MANUAL: 'MANUAL',
};
/** 화면 표기 정본 — 연결이 얼마나 믿을 만한지 한 낱말로. */
export const REMEDIATION_MATCH_SOURCE_LABELS = {
    REPORT_NO: '번호 일치',
    STORE_TIME: '매장·시간 추정',
    MANUAL: '직접 지정',
};
export const RemediationStatus = {
    REVISIT_NEEDED: 'REVISIT_NEEDED',
    IN_PROGRESS: 'IN_PROGRESS',
    // 조치는 했고 원인을 찾는 중(2026-10-28 오너). 노션 Open 을 옮겨 오는 자리.
    OBSERVING: 'OBSERVING',
    MONITORING: 'MONITORING',
    COMPLETED: 'COMPLETED',
};
/** 화면 표기 정본. 시트가 쓰는 말을 그대로 옮겼다. */
export const REMEDIATION_STATUS_LABELS = {
    REVISIT_NEEDED: '재방문 필요',
    IN_PROGRESS: '조치 진행 중',
    OBSERVING: '조치 후 원인 파악 중',
    MONITORING: '모니터링',
    // 2026-10-28 오너 "조치 완료는 해결 완료로 이름을 바꾸자".
    COMPLETED: '해결 완료',
};
/**
 * 고장 조치 이력의 구분 — 노션 'Field Issue Tracking' 의 Sort 칸과 같은 두 갈래(2026-10-27).
 * 사람이 정하지 않은 줄은 키워드로 자동 분류한다(`classifyIssueCategory`).
 */
export const IssueCategory = {
    ROBOT: 'ROBOT',
    NON_ROBOT: 'NON_ROBOT',
};
/** 화면 표기 정본. 노션이 쓰는 말 그대로. */
export const ISSUE_CATEGORY_LABELS = {
    ROBOT: '로봇 이슈',
    NON_ROBOT: '로봇 외 이슈',
};
export const ServiceSeverity = {
    P1: 'P1', // 30 min triage / 4 h resolve / 24 h verify
    P2: 'P2', //  4 h triage / 24 h resolve /  7 d verify
    P3: 'P3', // 24 h triage /  7 d resolve / 30 d verify
};
// plan-field-service-orders.md §F-1 / §3 — 9-state
// lifecycle. OPEN → TRIAGED → ASSIGNED → IN_PROGRESS →
// RESOLVED → VERIFIED → CLOSED. BLOCKED + CANCELLED are
// side-paths reachable from any state. Auto-CANCEL fires
// when the parent acceptance is voided after auto-create.
export const ServiceOrderStatus = {
    OPEN: 'OPEN',
    TRIAGED: 'TRIAGED',
    ASSIGNED: 'ASSIGNED',
    IN_PROGRESS: 'IN_PROGRESS',
    BLOCKED: 'BLOCKED',
    RESOLVED: 'RESOLVED',
    VERIFIED: 'VERIFIED',
    CLOSED: 'CLOSED',
    CANCELLED: 'CANCELLED',
};
// ── 서비스 오더 어휘 한글 라벨 (정본) ─────────────────────────────────────
//
// 26-09-11 — 고객사 리포트(시트 수집분) 화면이 같은 어휘를 쓰면서 추가했다.
// 콘솔에 이미 SEVERITY_LABEL 지역 사본이 3곳(ServiceOrdersInboxPage,
// ServiceOrderCreateModal, dashboard/FieldDashboardPage) 있는데, 저장소 관례는
// `*_LABELS` 를 여기 두는 것이다(ROBOT_STATUS_LABELS 등). 새 화면부터 정본을
// 쓰고, 기존 3곳은 별도 차수에 이관한다.
export const SERVICE_SEVERITY_LABELS = {
    P1: 'P1 · 긴급',
    P2: 'P2 · 일반',
    P3: 'P3 · 낮음',
};
/**
 * 고객사 리포트(시트 수집)에서 '끝난' 상태 — 미해결은 이 밖(대기 · 진행중). 리포트 목록의 미해결 거르기와
 * 필드 대시보드 '미해결 리포트'가 같은 셈이어야 해서 한 벌로 둔다(2026-10-27).
 */
export const SHEET_REPORT_CLOSED_STATUSES = [
    'RESOLVED',
    'VERIFIED',
    'CLOSED',
    'CANCELLED',
];
export const SERVICE_ORDER_STATUS_LABELS = {
    OPEN: '신규',
    TRIAGED: '분류완료',
    ASSIGNED: '배정',
    IN_PROGRESS: '진행중',
    BLOCKED: '대기',
    RESOLVED: '해결',
    VERIFIED: '검증',
    CLOSED: '종결',
    CANCELLED: '취소',
};
export const SERVICE_ORDER_CATEGORY_LABELS = {
    PREVENTIVE: '정기점검',
    REACTIVE: '긴급조치',
    INSTALL: '설치',
    REMOVAL: '회수',
    PARTS_SWAP: '부품교체',
};
// plan-field-service-orders.md §F-1 — append-only event log
// types. Drives the timeline UI on the SO detail page +
// realtime broadcast over the existing `domain` socket. The
// `payload` JSON column is typed by this enum (see F-2).
export const ServiceOrderEventType = {
    CREATED: 'CREATED',
    STATUS_CHANGED: 'STATUS_CHANGED',
    ASSIGNED: 'ASSIGNED',
    NOTE_ADDED: 'NOTE_ADDED',
    PARTS_ADDED: 'PARTS_ADDED',
    PHOTO_ADDED: 'PHOTO_ADDED',
    SLA_BREACHED: 'SLA_BREACHED',
    ESCALATED: 'ESCALATED',
    CANCELLED: 'CANCELLED',
    CUSTOMER_REASSIGNED: 'CUSTOMER_REASSIGNED',
    // round7 §1-5 (D5) — 등급(severity) 재분류 + SLA 마감 재계산.
    SEVERITY_CHANGED: 'SEVERITY_CHANGED',
};
// --- MenuOffering (v1.1) — 31×7 store-menu-cookingMethod matrix --------
export const ProteinSegment = {
    PORK: 'PORK',
    BEEF: 'BEEF',
    CHICKEN: 'CHICKEN',
    LAMB: 'LAMB',
    FISH: 'FISH',
    INJECTED: 'INJECTED',
};
export const CookingMethod = {
    MAILLARD_GAS: 'MAILLARD_GAS',
    NEW_MAILLARD: 'NEW_MAILLARD',
    CAST_CHARCOAL: 'CAST_CHARCOAL',
    DIRECT_GAS: 'DIRECT_GAS',
    GRILL_CHARCOAL: 'GRILL_CHARCOAL',
    GRIDDLE_ELECTRIC: 'GRIDDLE_ELECTRIC',
    OVEN_PLUS: 'OVEN_PLUS',
};
// ============================================================
// v0.4.0 — Parts / Solution / Defect-LOT tracking
// docs/plan/v0.4.0-parts-solution-defect-lot/plan.md §2
// ============================================================
export const PartCategory = {
    GRILLER: 'GRILLER',
    LOADER: 'LOADER',
    GAS_VALVE: 'GAS_VALVE',
    FIRMWARE_BOARD: 'FIRMWARE_BOARD',
    SENSOR_SUITE: 'SENSOR_SUITE',
    POWER_UNIT: 'POWER_UNIT',
    CONSUMABLE: 'CONSUMABLE',
    ACCESSORY: 'ACCESSORY',
};
export const DefectStatus = {
    NORMAL: 'NORMAL',
    SUSPECTED: 'SUSPECTED',
    CONFIRMED: 'CONFIRMED',
    CLEARED: 'CLEARED',
};
export const SolutionCategory = {
    MEAT: 'MEAT',
    SEAFOOD: 'SEAFOOD',
    VEGETABLE: 'VEGETABLE',
    DEMO: 'DEMO',
    CUSTOM: 'CUSTOM',
};
export const SolutionStatus = {
    BETA: 'BETA',
    STABLE: 'STABLE',
    DEPRECATED: 'DEPRECATED',
    RETIRED: 'RETIRED',
};
export const DefectSeverity = {
    SUSPECTED_AUTO: 'SUSPECTED_AUTO',
    CONFIRMED_MINOR: 'CONFIRMED_MINOR',
    CONFIRMED_MAJOR: 'CONFIRMED_MAJOR',
    FALSE_POSITIVE: 'FALSE_POSITIVE',
};
// v0.4.0 §2.3 — RobotPart.removalReason 의 권장 값 (DB 는 free-text).
export const PartRemovalReason = {
    WEAR: 'WEAR',
    DEFECT: 'DEFECT',
    UPGRADE: 'UPGRADE',
    RECALL: 'RECALL',
};
// docs/plan/v0.5.0-telemetry-supplier-inventory-predictive/plan.md §4 — Supplier 분류.
export const SupplierCategory = {
    GRILLER_SPECIALIST: 'GRILLER_SPECIALIST',
    LOADER_SPECIALIST: 'LOADER_SPECIALIST',
    SENSOR_SPECIALIST: 'SENSOR_SPECIALIST',
    GENERAL: 'GENERAL',
    OVERSEAS: 'OVERSEAS',
};
// ── plan-modusign-style-acceptance §Phase1 — e-Sign Platform enums ──────────
export const SignatureDocumentType = {
    DELIVERY_RECEIPT: 'DELIVERY_RECEIPT', // 인수증
    INSTALLATION_TRAINING: 'INSTALLATION_TRAINING', // 설치·교육 인수증
    REMOTE_SERVICE_CONSENT: 'REMOTE_SERVICE_CONSENT', // 데이터 수집·이용 동의서
    CUSTOM: 'CUSTOM', // 사용자 정의
};
export const SignatureDocumentStatus = {
    DRAFT: 'DRAFT', // 초안 (발송 전)
    IN_PROGRESS: 'IN_PROGRESS', // 서명 진행 중
    COMPLETED: 'COMPLETED', // 전원 서명 완료 (immutable)
    CANCELLED: 'CANCELLED', // 취소
};
export const SignatureSignatoryStatus = {
    PENDING: 'PENDING', // 서명 대기
    OPENED: 'OPENED', // 토큰 URL 열람
    SIGNED: 'SIGNED', // 서명 완료
    DECLINED: 'DECLINED', // 거부 (확장용)
};
export const SignatureSignatoryChannel = {
    IN_PERSON: 'IN_PERSON', // 대면 서명 (운영자 결정 #2)
};
export const SignatureSignOrder = {
    SEQUENTIAL: 'SEQUENTIAL', // 순서대로
    PARALLEL: 'PARALLEL', // 동시 서명
};
// ============================================================
// 로더(로봇 팔) 이력·역추적 — docs/plan/loader-history-traceability-2026-07
// Prisma LoaderProductionKind / LoaderInspection / LoaderStatus /
// LoaderRemovalReason 미러. 값 변경 시 schema.prisma 동기화 + prisma generate.
// ============================================================
export const LoaderProductionKind = {
    OUTSOURCED: 'OUTSOURCED', // L — 외주(H5)
    IN_HOUSE: 'IN_HOUSE', // H — 사내 생산/수리
};
export const LOADER_PRODUCTION_KIND_LABELS = {
    OUTSOURCED: '외주(H5)',
    IN_HOUSE: '사내',
};
// 입고검사 판정. 오너 결정(2026-08-03) — 로더 대장에 실제로 쓰이던 '조건부합격'을
// 정식 값으로 추가(종전 3값). 선언 순서 = 판정 강도 순(대기 → 합격 → 조건부합격 →
// 불합격) 이고 아래 라벨 맵 순서가 화면 선택지 순서다 — 등록 폼·편집 모달이 둘 다
// LOADER_INSPECTION_LABELS 를 훑어 <option> 을 만들므로 여기가 정본이다.
export const LoaderInspection = {
    PENDING: 'PENDING',
    PASS: 'PASS',
    CONDITIONAL: 'CONDITIONAL',
    FAIL: 'FAIL',
};
export const LOADER_INSPECTION_LABELS = {
    PENDING: '대기',
    PASS: '합격',
    CONDITIONAL: '조건부합격',
    FAIL: '불합격',
};
export const LoaderStatus = {
    IN_STOCK: 'IN_STOCK', // 재고(재사용 대기)
    INSTALLED: 'INSTALLED', // 로봇에 장착됨
    IN_REPAIR: 'IN_REPAIR', // 수리중
    RETIRED: 'RETIRED', // 폐기
};
export const LOADER_STATUS_LABELS = {
    IN_STOCK: '재고',
    INSTALLED: '장착됨',
    IN_REPAIR: '수리중',
    RETIRED: '폐기',
};
// 탈거 사유. '마모'→'내구성' 확정(2026-07-22). SWAP 은 가져오기(재작업 승계)용.
//
// TRANSPLANT 추가(26-08-06 오너 요구 '로더 분리·이식') — 기존 6개 선택지는 전부
// "로더에 문제가 있어서" 계열이라, 멀쩡한 로더를 다른 로봇에 옮기는 이식은 고를 사유가
// 없었다. 억지로 UPGRADE 등을 고르게 하면 **로더 품질 통계가 거짓**이 된다(멀쩡한 로더가
// 문제 있던 것으로 집계). 값 하나로 사실을 표현한다.
export const LoaderRemovalReason = {
    DURABILITY: 'DURABILITY',
    DEFECT: 'DEFECT',
    SW_BUG: 'SW_BUG',
    HW_BUG: 'HW_BUG',
    UPGRADE: 'UPGRADE',
    RECALL: 'RECALL',
    SWAP: 'SWAP',
    TRANSPLANT: 'TRANSPLANT',
};
export const LOADER_REMOVAL_REASON_LABELS = {
    DURABILITY: '내구성',
    DEFECT: '불량',
    SW_BUG: '소프트웨어 문제',
    HW_BUG: '하드웨어 문제',
    UPGRADE: '업그레이드',
    RECALL: '리콜',
    SWAP: '교체(재작업)',
    TRANSPLANT: '이식(다른 로봇 장착)',
};
// 현장/제조에서 사용자가 교체·분리 시 고를 수 있는 사유(SWAP 제외 — 그것은 시스템 승계용).
export const LOADER_REMOVAL_REASON_CHOICES = [
    'DURABILITY',
    'DEFECT',
    'SW_BUG',
    'HW_BUG',
    'UPGRADE',
    'RECALL',
    'TRANSPLANT',
];
// ============================================================
// 로더 개조 대장(엑셀) 업로드 상태 — docs/plan/loader-rev-excel-upload-2026-09
// ============================================================
//
// 업로드 → 읽기(비교) → 확정 의 단계를 한 행이 들고 간다. 확정 전에는 콘솔 데이터가
// 바뀌지 않는다(요구 3). 취소해도 파일과 이력은 남는다.
export const LoaderRevUploadStatus = {
    /** 업로드 주소만 발급 — 아직 읽지 않았다. */
    PENDING: 'PENDING',
    /** 읽고 비교까지 끝 — 확정 대기. */
    PREVIEWED: 'PREVIEWED',
    /** 반영 완료. */
    CONFIRMED: 'CONFIRMED',
    /** 사람이 취소(파일은 보관). */
    CANCELLED: 'CANCELLED',
};
//# sourceMappingURL=enums.js.map